export default {"src":"/_next/static/media/ala.be327fcf.svg","height":223,"width":363,"blurWidth":0,"blurHeight":0};